import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloPredibattimento extends FascicoloFull {
  provenienzaFascicolo: string;
  numeroRegistroGeneraleAffariPenali: string;
  sezione: string;
  pubblicoMinistero: string;
  prove: string;
  sufficienzaProve: boolean;
  misureCautelari: boolean;
  misuraAdottata: string;
  richiestaOblazione: boolean;

  constructor() {
    super();
    this.dataInizioFascicolo = +new Date();
  }
}
